<template>  <customer-form ref="form" mode="create" /></template>
<script>
import CustomerForm from '../../components/customer-form'
import formRoute from '../../common/form-route'
export default { components: { CustomerForm }, mixins: [formRoute] }
</script>



// WEBPACK FOOTER //
// src/pages/customer/create.vue